import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { FaPhone, FaWhatsapp, FaBirthdayCake, FaPhoneAlt } from 'react-icons/fa';
import { Card, CardHeader, CardBody, CardFooter, SimpleGrid } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { leadGet } from '../../../redux/actions/Files.action';
import moment from 'moment';
import { BASEURL } from 'baseUrl';
import userPhoto from '../../../assets/img/user.png';

export default function BirthdayList() {
  const dispatch = useDispatch();
  const getFile = useSelector((state) => state.files);
  const [todayBirthdays, setTodayBirthdays] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment().format('YYYY-MM-DD'));
  const [selectedName, setSelectedName] = useState('');

  useEffect(() => {
    dispatch(leadGet(1, 1000)); // Fetch all leads with high limit
  }, []);

  useEffect(() => {
    if (getFile?.getAllLead?.data?.PatientData) {
      const filterDate = moment(selectedDate).format('MM-DD');
      const birthdays = getFile.getAllLead.data.PatientData.filter(patient => {
        if (!patient.dateOfBirth) return false;
        const dob = moment(patient.dateOfBirth).format('MM-DD');
        return dob === filterDate;
      });
      setTodayBirthdays(birthdays);
    }
  }, [getFile, selectedDate]);

  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const openWhatsapp = (phoneNumber, firstName, lastName) => {
    const fullName = `${firstName}`;
    // Birthday card image URL - replace with your actual hosted image URL
    // const birthdayImageUrl = "../../../../public/zokep-fav.png";  
    const message = `Dear ${fullName},\n\nHappy Birthday! 🎉🎂\n\nWe at zokep CRM wish you a wonderful birthday filled with joy and happiness. Thank you for being a valued part of our family.\n\nBest Regards,\nzokep CRM Team`;
    // const message = `Dear ${fullName},\n\nHappy Birthday! 🎉🎂\n\nWe at Trip Well wish you a wonderful birthday filled with joy and happiness. Thank you for being a valued part of our family.\n\nBest Regards,\nTRIP WELL Team`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`, '_blank');
  };

  const handleNameClick = (firstName, lastName) => {
    const fullName = `${firstName} ${lastName}`;
    setSelectedName(selectedName === fullName ? '' : fullName);
  };

  return (
    <div className="mt-[100px]">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
        {/* Title section - always on top for mobile */}
        <div className="flex items-center">
          <FaBirthdayCake className="text-[#F15A30] text-2xl" />
          <h2 className="text-2xl font-bold ml-3">
            {moment(selectedDate).isSame(moment(), 'day')
              ? "Today's Birthdays"
              : `Birthdays on ${moment(selectedDate).format('MMMM Do')}`
            }
          </h2>
        </div>

        {/* Filter controls - below title on mobile, right-aligned on desktop */}
        <div className="flex flex-wrap items-center gap-2">
          <label htmlFor="birthday-date" className="text-sm font-medium text-gray-700 whitespace-nowrap">
            Filter by date:
          </label>
          <div className="flex flex-1 min-w-[200px] gap-2">
            <input
              id="birthday-date"
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="flex-1 border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-sm"
            />
            <button
              onClick={() => setSelectedDate(moment().format('YYYY-MM-DD'))}
              className="bg-[#F15A30] hover:bg-[#d94f29] text-white px-3 py-2 rounded text-sm whitespace-nowrap"
            >
              Today
            </button>

          </div>
        </div>
      </div>

      {/* Birthday count indicator */}
      <p className="text-gray-600 mb-4">
        {todayBirthdays.length} {todayBirthdays.length === 1 ? 'person' : 'people'} celebrating {moment(selectedDate).isSame(moment(), 'day') ? 'today' : 'on this day'}
      </p>

      {/* Rest of your component */}
      {selectedName && (
        <div className="fixed bottom-4 right-4 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg shadow-lg z-50 animate-fade-in">
          {selectedName}
        </div>
      )}

      {todayBirthdays.length > 0 ? (
        <div className="overflow-x-auto bg-white rounded-xl shadow-lg border border-gray-100">
          <table className="w-full text-left border-collapse table-auto">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200 text-gray-600 text-xs uppercase font-bold tracking-wider">
                <th className="py-3 px-4">Name</th>
                <th className="py-3 px-4">Phone</th>
                <th className="py-3 px-4">Date of Birth</th>
                <th className="py-3 px-4">Registered Date</th>
                <th className="py-3 px-4 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-sm">
              {todayBirthdays.map((patient) => (
                <tr key={patient._id} className="hover:bg-blue-50/40 transition-colors">
                  <td className="py-3 px-4 font-semibold text-blue-900">
                    <div className="flex items-center gap-2.5">
                      <img
                        src={patient.photo || userPhoto}
                        alt="avatar"
                        className="w-8 h-8 rounded-full object-cover border border-gray-200 shadow-sm"
                        onError={(e) => { e.target.onerror = null; e.target.src = userPhoto; }}
                      />
                      <span
                        className="cursor-pointer hover:text-yellow-600 transition-colors"
                        onClick={() => handleNameClick(patient.firstName, patient.lastName)}
                      >
                        {patient.firstName} {patient.lastName}
                      </span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-gray-700 font-medium">
                    {patient.phoneNumber}
                  </td>
                  <td className="py-3 px-4 text-gray-600 font-medium">
                    <div className="flex items-center gap-1.5 text-yellow-600">
                      <FaBirthdayCake />
                      <span>{patient.dateOfBirth ? moment(patient.dateOfBirth).format('DD/MM/YYYY') : '-'}</span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-gray-600">
                    {patient.createdAt ? moment(patient.createdAt).format('DD/MM/YYYY') : '-'}
                  </td>
                  <td className="py-3 px-4 text-center">
                    <div className="flex items-center justify-center gap-3">
                      <button
                        onClick={() => handlePhoneClick(patient.phoneNumber)}
                        className="text-blue-500 hover:text-blue-700 transition-transform hover:scale-110"
                        title="Call"
                      >
                        <FaPhoneAlt size={18} />
                      </button>
                      <button
                        onClick={() =>
                          openWhatsapp(patient.phoneNumber, patient.firstName, patient.lastName)
                        }
                        className="text-green-500 hover:text-green-700 transition-transform hover:scale-110"
                        title="WhatsApp"
                      >
                        <FaWhatsapp size={20} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>


      ) : (
        <div className="text-center py-12 bg-white rounded-lg shadow-sm">
          <FaBirthdayCake className="text-gray-300 text-5xl mx-auto" />
          <p className="mt-4 text-xl text-gray-500 font-medium">
            No birthdays to celebrate today
          </p>
        </div>
      )}





    </div>
  );
}